import { css } from 'styled-components';

import { deviceBreakpoints } from '../../hooks/useDeviceQuery.hook';
import { colorsV2 } from '../colors-v2';

export const sharedFontStyles = css`
  font-family: noto-serif, serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  color: ${colorsV2.black100};
  h2 {
    font-size: 24px;
    font-weight: 600;
    line-height: 36px;
  }
  h3 {
    font-size: 20px;
    font-weight: 500;
    line-height: 30px;
  }

  @media ${deviceBreakpoints.fromTablet} {
    font-size: 20px;
    line-height: 32px;
    h2 {
      font-size: 32px;
      line-height: 48px;
    }
    h3 {
      font-size: 24px;
      line-height: 36px;
    }
  }
`;
